import { render, staticRenderFns } from "./twenty_percent.vue?vue&type=template&id=26363915&scoped=true"
import script from "./twenty_percent.vue?vue&type=script&lang=js"
export * from "./twenty_percent.vue?vue&type=script&lang=js"
import style0 from "./twenty_percent.vue?vue&type=style&index=0&id=26363915&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26363915",
  null
  
)

export default component.exports